import { render, staticRenderFns } from "./IconFranchiseFilial.vue?vue&type=template&id=0c666271&scoped=true&"
import script from "./IconFranchiseFilial.vue?vue&type=script&lang=js&"
export * from "./IconFranchiseFilial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c666271",
  null
  
)

export default component.exports